import axios from "axios";
export const httpPublic = axios.create({
  baseURL: "https://snappy.uz/api",
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  withCredentials: true,
});

const http = axios.create({
  // baseURL: "http://localhost:8081/api",
  baseURL: "https://snappy.uz/api",
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  withCredentials: true,
});

const refreshInstance = axios.create({
  // baseURL: "http://localhost:8081/api",
  baseURL: "https://snappy.uz/api",
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  withCredentials: true,
});
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
http.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");

        if (!refreshToken) {
          localStorage.removeItem("accessToken");
          window.location.href = "/login";
          return Promise.reject(error);
        }
        const response = await refreshInstance.post("/auth/refresh-token", {
          token: localStorage.getItem("accessToken"),
          refreshToken: refreshToken,
        });
        const { token, refresh_token } = response.data;
        localStorage.setItem("accessToken", token);
        localStorage.setItem("refreshToken", refresh_token);
        originalRequest.headers["Authorization"] = `Bearer ${token}`;
        return http(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default http;
